"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var formjs_1 = require("@smartsheet-dataflow/formjs");
exports.setComponentAction = (_a = formjs_1.createInputFeature('component'), _a.actionCreator), exports.componentSelector = _a.selectorCreator, exports.ComponentFeature = _a.featureReducer;
//# sourceMappingURL=component.js.map